module.exports = __webpack_public_path__ + "img/Laguna artificial.46374ebf.png";